<template>
    <div class="agreement">
        <div>
<div>
        <div class="content">
            <p>In the event that EDUrent, LLC (“EDUrent”) refers Rental Prospect(s) (“Prospect”) to (“Property”),
            <v-text-field
                        v-model="propertyName"
                        label="Property Name"
                        required
                        outlined
                        dense
            >
            </v-text-field>(“Management/Owner”)
                <v-text-field
                        v-model="propertyOwner"
                        label="Management/Owner"
                        required
                        outlined
                        dense
                        @input="() => {this.$store.commit('setAgreementAgreement', {propertyName: propertyName, propertyOwner: propertyOwner})}"
                >
                </v-text-field>
                agree(s) to the following:</p>
            <p>In consideration for referral of Prospect and upon executed Agreement between Prospect and Management/Owner, and upon Prospect Move-In, Management/Owner shall compensate EDUrent in the amount of:</p>
            <p>${{price}} flat fee of any apartment leased by prospect</p>
        </div>
        <hr>
        <div class="content small-print">
            <p>If Property or Management/Owner redirects Prospect to alternative property not listed above and property is controlled by Management/Owner then this shall constitute a referral and EDUrent shall be compensated according to above terms.</p>
            <p>This compensation amount is confidential and not to be disclosed to any competitive Entities, Locators, Real Estate Brokerages or other individuals not directly associated with this agreement.</p>
            <p>The receipt of said consideration being acknowledged as adequate by each Party, and their respective agents, insurers, successors, assigns, heirs, beneficiaries, executors, administrators and legal representatives herby mutually agree to uphold this agreement.</p>
            <p>Any and all Prospects of EDUrent affiliated colleges shall be credited to EDUrent for compensation regardless of the source of identifying how the Prospect discovered Management/Owner Property(s).</p>
            <p>All account payables shall be paid in full to the company name and address listed at the bottom of this agreement and not more than 30 days subsequent to the date of invoicing.</p>
            <p>This Agreement is effective for 1 (one) year from the effective start date.  This Agreement will automatically renew on an annual basis.  This agreement may be terminated by either party with 30 (thirty) days notice in writing.</p>
            <p>In the event any litigation, mediation, arbitration or controversy between the parties hereto arises out of or relates to this agreement, the prevailing party shall be entitled to recover from the other party all collection costs, reasonable attorneys’ fees, expenses and suit costs including those associated with any appellate proceedings or any post-judgement collection proceedings.  </p>
        </div>

    </div>
        </div>
        <AgreementForm/>
    </div>
</template>

<script>
    import AgreementForm from './AgreementForm.vue'
    export default {
        name: "Agreement",
        data() {
            return {
                propertyName: "",
                propertyOwner: ""
            }
        },
        props: {
            price: {
                type: Number,
                default: 299,
            },
        },
        components: {
            AgreementForm
        },
        computed: {
            isFilled() {
                return this.propertyName.length > 1 && this.propertyOwner.length > 1
            }
        },
        watch: {
            isFilled(val) {
                this.$store.commit('setAgreementComplete', val)
            }
        },
    }
</script>

<style lang="scss" scoped>
.property-name {
    border: black 1px solid;
    height: 1.5em;
    padding: 0.5em 0.5em;
    border-radius: 5px;
}

.agreement {
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 250%;
    color: #000000;
}
    div.hero h1 {
        color: white !important;
    }
    div.hero {
        padding: 60px;
    }
    div.content {
        max-width: 1024px;
        margin-top: 3em;
        margin-bottom: 3em;
    }
    p, h1, h2, h3, h4, ul, li {
        margin-top: 0.8em;
    }
    hr {
        margin-top: 3em;
    }
    .small-print p {
        font-size: 0.8em;

    }
    div.contact-form div {
        padding-bottom: 0;
        padding-top: 0;
    }
    div.contact-form {
        border-radius: 10px;
    }

</style>
